import { render, staticRenderFns } from "./GPathSchoolDashboard.vue?vue&type=template&id=18e92ee8"
import script from "./GPathSchoolDashboard.vue?vue&type=script&lang=js"
export * from "./GPathSchoolDashboard.vue?vue&type=script&lang=js"
import style0 from "./GPathSchoolDashboard.vue?vue&type=style&index=0&id=18e92ee8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports